module.exports = __webpack_public_path__ + "img/fhy.d3fe30a.svg";